var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhyRak2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5701",
    "data-name": "Group 5701",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.064,
    height: 53.064,
    viewBox: "0 0 53.064 53.064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14890",
    "data-name": "Path 14890",
    d: "M28.1,1.558v2.29a3.952,3.952,0,0,0-3.143,0V1.558A1.572,1.572,0,0,1,28.1,1.558ZM3.939,39.9H20.952V37.766l4.01-1.354V11.14a3.981,3.981,0,0,0,3.143,0V36.411l4.007,1.354V39.9H53.064v2.486H4.516A2.457,2.457,0,0,0,2.067,44.84v3.287a2.457,2.457,0,0,0,2.449,2.452H53.064v2.486H3.939A3.949,3.949,0,0,1,0,49.125V43.84A3.951,3.951,0,0,1,3.939,39.9Zm1.076,3.435H52.131a5.34,5.34,0,0,0,0,6.292H5.015a1.744,1.744,0,0,1-1.953-1.882V45.219A1.727,1.727,0,0,1,5.015,43.337ZM41.232,8.468h-12a2.873,2.873,0,0,1-5.4,0h-12l5.632,16.748h.7c0,3.711-3.493,6.719-7.8,6.719s-7.805-3.008-7.805-6.719h.7l6.287-18.7H23.83a2.874,2.874,0,0,1,5.4,0H43.528l6.289,18.7h.694c0,3.711-3.493,6.719-7.8,6.719S34.9,28.927,34.9,25.216h.7ZM37.424,25.216H47.991L42.709,9.5Zm-32.351,0H15.64L10.358,9.5Zm21.46-18.86a1.138,1.138,0,1,1-1.14,1.137A1.137,1.137,0,0,1,26.533,6.356Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhyRak2);
export default __webpack_public_path__ + "static/media/icon-why-rak-2.c64dde16a01086b71109d2d7a0e942d2.svg";
export { ForwardRef as ReactComponent };